/**
 * Copyright (C) 2024-present Puter Technologies Inc.
 *
 * This file is part of Puter.
 *
 * Puter is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

const ig = {
  name: "Igbo",
  english_name: "Igbo",
  code: "ig",
  dictionary: {
    about: "banyere",
    account: "akaụntụ",
    account_password: "nyochaa paswọọdụ akaụntụ",
    access_granted_to: "Enyere ohere",
    add_existing_account: "Tinye Akaụntụ dị adị",
    all_fields_required: "A chọrọ mpaghara niile.",
    allow: "ekwe",
    apply: "Tinye",
    ascending: "Na-arịgo",
    associated_websites: "Weebụsaịtị Ejikọtara",
    auto_arrange: "ndokwa onwe",
    background: "ndabere",
    browse: "Chọgharịa",
    cancel: "Kagbuo",
    center: "etiti",
    change_desktop_background: "ịgbanwe ndabere desktọpụ…",
    change_email: "ịgbanwe email",
    change_language: "ịgbanwe Asụsụ",
    change_password: "ịgbanwe paswọọdụ",
    change_ui_colors: "ịgbanwe agba UI",
    change_username: "ịgbanwe aha njirimara",
    close: "mmechi",
    close_all_windows: "mmechi Windows niile",
    close_all_windows_confirm: "Ị ji n'aka na ị chọrọ imechi windo niile?",
    close_all_windows_and_log_out: "mmechi Windows na wee pụọ",
    change_always_open_with: "Ị chọrọ I na mepee ụdị faịlụ site na",
    color: "Agba",
    confirm: "gosi",
    confirm_2fa_setup: "Etinyela m koodu ahụ na ngwa nyocha m",
    confirm_2fa_recovery: "Echekwala m koodu mgbake m na ebe echedoro",
    hue: "Hue",
    confirm_account_for_free_referral_storage_c2a:
      "Mepụta akaụntụ wee kwado adreesị ozi-e gị iji nweta 1 GB nke nchekwa efu. Enyi gị ga-enwetakwa 1 GB nke nchekwa efu.",
    confirm_code_generic_incorrect: "Koodu ezighi ezi.",
    confirm_code_generic_too_many_requests:
      "Ọtụtụ ọchịchọ. Biko chere nkeji ole na ole.",
    confirm_code_generic_submit: "Nye koodu",
    confirm_code_generic_try_again: "Nwa ọzọ",
    confirm_code_generic_title: "Tinye koodu Nkwenye",
    confirm_code_2fa_instruction:
      "Tinye koodu ọnụọgụ isi site na ngwa nyocha gị.",
    confirm_code_2fa_submit_btn: "tinye",
    confirm_code_2fa_title: "Tinye koodu 2FA",
    confirm_delete_multiple_items:
      "Ị ji n'aka na ịchọrọ ihichapụ ihe ndị a kpamkpam?",
    confirm_delete_single_item: "Ịchọrọ ihichapụ ihe a kpamkpam?",
    confirm_open_apps_log_out:
      "Ị nwere ngwa mepere emepe. Ị ji n'aka na ị chọrọ ịpụ?",
    confirm_new_password: "Kwenye paswọọdụ ọhụrụ",
    confirm_delete_user:
      "Ị ji n'aka na ịchọrọ ihichapụ akaụntụ gị? A ga-ehichapụ faịlụ gị niile na data gị kpamkpam. Enweghị ike imegharị ihe a.",
    confirm_delete_user_title: "Hichapụ Akaụntụ?",
    confirm_session_revoke: "O doro gị anya na ịchọrọ kagbuo nnọkọ a?",
    confirm_your_email_address: "Kwenye na adreesị email",
    contact_us: "Kpọtụrụ anyị",
    contact_us_verification_required:
      "Ị ga-enwerịrị adreesị email ekwenyesiri ike ka ị jiri nke a.",
    contain: "nwere",
    continue: "Gaa n'ihu",
    copy: "Detuo",
    copy_link: "Detuo njikọ",
    copying: "n'ide",
    copying_file: "n'ide %%",
    cover: "Mkpuchi",
    create_account: "Mepe akaụntụ",
    create_free_account: "Mepụta Akaụntụ efu",
    create_shortcut: "Mepụta Ụzọ mkpirisi",
    credits: "Ebe e si nweta",
    current_password: "paswọọdụ Ugbu a",
    cut: "Bee",
    clock: "Elekere",
    clock_visible_hide: "Ezo - ezoro ezo mgbe niile",
    clock_visible_show: "Gosi - A na-ahụ ya mgbe niile",
    clock_visible_auto:
      "Nchekwa onwe - Emepụtara, a na-ahụ ya naanị na ọnọdụ ihuenyo zuru oke.",
    close_all: "Mechie ha niile",
    created: "kere",
    date_modified: "Ụbọchị ịgbanwe",
    default: "Default",
    delete: "Hichapụ",
    delete_account: "Hichapụ Akaụntụ",
    delete_permanently: "Hichapụ kpamkpam",
    deleting_file: "ihichapụ %%",
    deploy_as_app: "Bugharịa dị ka ngwa",
    descending: "agbadata",
    desktop: "desktọpụ",
    desktop_background_fit: "dabara",
    developers: "Ndị mme ya",
    dir_published_as_website: `%strong% e bipụtara ya:`,
    disable_2fa: "Gbanyụọ 2FA",
    disable_2fa_confirm: "Ị ji n'aka na ịchọrọ gbanyụọ 2FA?",
    disable_2fa_instructions: "Tinye paswọọdụ gị i ji gbanyụọ 2FA.",
    disassociate_dir: "hapụ Akwụkwọ ndekọ",
    documents: "akwụkwọ",
    dont_allow: "Ekwela",
    download: "Budata",
    download_file: "Budata faịlụ",
    downloading: "Nbudata",
    email: "Email",
    email_change_confirmation_sent:
      "ezipula email nkwenye na adreesị ozi-e ọhụrụ gị. Biko lelee igbe mbata gị ma soro ntuziaka ka ịmechaa usoro ahụ.",
    email_invalid: "Email adịghị mma.",
    email_or_username: "Email ma ọ bụ aha njirimara",
    email_required: "Email bu ihe achọrọ.",
    empty_trash: "Mkpofu ahịhịa",
    empty_trash_confirmation: `Ị ji n'aka na ịchọrọ ihichapụ ihe ndị dị na ahịhịa?`,
    emptying_trash: "Mkpofu ahịhịa…",
    enable_2fa: "Kwado 2FA",
    end_hard: "Kwụsị ike",
    end_process_force_confirm:
      "O doro gị anya na ịchọrọ ịmanye-akwụsị usoro a?",
    end_soft: "Kwụsị nwayọọ",
    enlarged_qr_code: "gbasawanyere QR Koodu",
    enter_password_to_confirm_delete_user:
      "Tinye paswọọdụ gị iji kwado nhichapụ akaụntụ gị",
    error_message_is_missing: "Ozi mmebe na-efu.",
    error_unknown_cause: "Nhe amaghị ama mere.",
    error_uploading_files: "Ibulite faịlụ agaghị",
    favorites: "ọkacha mmasị",
    feedback: "nzaghachi",
    feedback_c2a:
      "Biko jiri fọm dị n'okpuru zitere anyị nzaghachi gị, nkwupụta gị na mkpesa ahụhụ.",
    feedback_sent_confirmation:
      "Daalụ maka ịkpọtụrụ anyị. Ọ bụrụ na ị nwere email metụtara akaụntụ gị, ị ga-anụghachi anyị ozugbo enwere ike.",
    fit: "dabara",
    folder: "nchekwa",
    force_quit: "ịkwụsị ike",
    forgot_pass_c2a: "Chefuru paswọọdụ?",
    from: "si",
    general: "Izugbe",
    get_a_copy_of_on_puter: `Nweta otu '%%' na Puter.com!`,
    get_copy_link: "Nweta njikọ nke",
    hide_all_windows: "Ezo Windows niile",
    home: "ụlọ",
    html_document: "akwụkwọ HTML",
    hue: "Hue",
    image: "Onyonyo",
    incorrect_password: "paswọọdụ ezighi ezi",
    invite_link: "Njikọ ịkpọ òkù",
    item: "ihe",
    items_in_trash_cannot_be_renamed: `Enweghị ike ịnyegharị ihe a aha n'ihi na ọ nọ na ahịhịa. Iji nyegharịa ihe a aha, buru ụzọ dọrọ ya na ahịhịa.`,
    jpeg_image: "Foto JPEG",
    keep_in_taskbar: "Debe na Taskbar",
    language: "Asụsụ",
    license: "ikike",
    lightness: "ìhè",
    link_copied: "depụtagha njikọ",
    loading: "Na-ebugo ibu",
    log_in: "Banye",
    log_into_another_account_anyway: "Banye na akaụntụ ọzọ na agbanyeghị",
    log_out: "pụọ",
    looks_good: "Ọ mara mma!",
    manage_sessions: "Jikwaa Oge",
    modified: "gbanwee",
    move: "Bugharịa",
    moving_file: "Na Bugharịa %%",
    my_websites: "Weebụsaịtị m",
    name: "Aha",
    name_cannot_be_empty: "Aha enweghị ike ịbụ ihe efu.",
    name_cannot_contain_double_period: "Aha enweghị ike ịbụ agwa '..'.",
    name_cannot_contain_period: "Aha enweghị ike ịbụ agwa '.'.",
    name_cannot_contain_slash: "Aha enweghị ike ịnwe agwa '/'.",
    name_must_be_string: "Aha nwere ike ịbụ naanị mkpụrụokwu.",
    name_too_long: `Aha enweghị ike kari %% mkpụrụedemede.`,
    new: "Ọhụrụ",
    new_email: "Email Ọhụrụ",
    new_folder: "nchekwa ọhụrụ",
    new_password: "paswọọdụ ọhụrụ",
    new_username: "Aha ọhụrụ njirimara",
    no: "Mba",
    no_dir_associated_with_site:
      "O nweghị akwụkwọ ndekọ aha jikọtara ya na adreesị a.",
    no_websites_published: "Ị bipụtabeghị webụsaịtị ọ bụla.",
    ok: "OK",
    open: "Mepee",
    open_in_new_tab: "Mepee na Tab ọhụrụ",
    open_in_new_window: "Mepee na window ọhụrụ",
    open_with: "Ji Mepee Ya",
    original_name: "Aha izizi",
    original_path: "Ụzọ izizi",
    oss_code_and_content: "Ngwanrọ na ọdịnaya mepere emepe",
    password: "paswọọdụ",
    password_changed: "gbanwere paswọọdụ.",
    password_recovery_rate_limit:
      "Ị ruru oke ọnụ ahịa anyị; biko chere nkeji ole na ole. Iji gbochie nke a n'ọdịnihu, zere ibugharị ibe ahụ ọtụtụ oge.",
    password_recovery_token_invalid:
      "Ihe mgbake mgbake okwuntughe adịkwaghị irè.",
    password_recovery_unknown_error:
      "Nhe amaghị ama mere. Biko nwaa ọzọ ma emechaa.",
    password_required: "Achọrọ paswọọdụ.",
    password_strength_error:
      "paswọọdụ ga-enwerịrị opekata mpe mkpụrụedemede 8 ma nwee opekata mpe otu mkpụrụedemede ukwu, otu mkpụrụedemede obere, otu nọmba na otu agwa pụrụ iche..",
    passwords_do_not_match:
      "`paswọọdụ ọhụrụ`  na `Kwenye paswọọdụ ọhụrụ` adabaghị.",
    paste: "tinye",
    paste_into_folder: "Tinye n'ime nchekwa",
    path: "ụzọ",
    personalization: "Nhazi onwe",
    pick_name_for_website: "Họrọ aha maka weebụsaịtị gị:",
    picture: "Foto",
    pictures: "Foto",
    plural_suffix: "s",
    powered_by_puter_js: `Kwadoro site na {{link=docs}}Puter.js{{/link}}`,
    preparing: "Na-akwado...",
    preparing_for_upload: "Na-akwado maka bulite...",
    print: "ebipụta",
    privacy: "Nzuzo",
    proceed_to_login: "Gaba na nbanye",
    proceed_with_account_deletion: "Gaa n'ihu na ihichapụ akaụntụ",
    process_status_initializing: "Na-amalite",
    process_status_running: "Na-agba ọsọ",
    process_type_app: "Ngwa",
    process_type_init: "Init",
    process_type_ui: "UI",
    properties: "Njirimara",
    public: "eze",
    publish: "Bipụta",
    publish_as_website: "Bipụta dị ka webụsaịtị",
    puter_description: `Puter bụ igwe ojii nzuzo nke mbụ iji dobe faịlụ gị, ngwa na egwuregwu gị n'otu ebe echekwara, enwere ike ịnweta ya ebe ọ bụla n'oge ọ bụla..`,
    reading_file: "ọgụgụ %strong%",
    recent: "Na nso nso a",
    recommended: "nwere ike ikwu",
    recover_password: "Weghachite paswọọdụ",
    refer_friends_c2a:
      "Nweta 1 GB maka enyi ọ bụla mepụtara ma kwado akaụntụ na Puter. Enyi gị ga-enwetakwa 1 GB!",
    refer_friends_social_media_c2a: `Nweta 1 GB nke nchekwa efu na Puter.com!`,
    refresh: "Weghachite ume",
    release_address_confirmation: `O doro gị anya na ịchọrọ wepụtara adreesị a?`,
    remove_from_taskbar: "Wepu na Taskbar",
    rename: "Nyegharịa aha",
    repeat: "megharịa",
    replace: "Dochie",
    replace_all: "Dochie ihe niile",
    resend_confirmation_code: "Tinyegharịa koodu nkwenye",
    reset_colors: "Tọgharịa Agba",
    restart_puter_confirm: "Ị ji n'aka na ịchọrọ ịmalitegharịa Puter?",
    restore: "weghachi",
    save: "chekwa",
    saturation: "juputa",
    save_account: "Chekwa akaụntụ",
    save_account_to_get_copy_link: "Biko mepụta akaụntụ iji gaa n'ihu.",
    save_account_to_publish: "Biko mepụta akaụntụ iji gaa n'ihu.",
    save_session: "Chekwa oge",
    save_session_c2a:
      "Mepụta akaụntụ iji chekwaa nnọkọ gị ugbu a ma zere ịla n'iyi ọrụ gị.",
    scan_qr_c2a:
      "Chọgharịa koodu dị n'okpuru ka ịbanye na nnọkọ a site na ngwaọrụ ndị ọzọ",
    scan_qr_2fa: "Jiri ngwa nyocha gị nyochaa QR koodu",
    scan_qr_generic: "Jiri ekwentị gị ma ọ bụ ngwaọrụ ọzọ nyochaa QR koodu a",
    search: "Chọọ",
    seconds: "sekọnd",
    security: "nche",
    select: "Họrọ",
    selected: "họrọ",
    select_color: "Họrọ agba…",
    sessions: "Oge",
    send: "Ziga",
    send_password_recovery_email: "Zipu ozi-e mgbake paswọọdụ ",
    session_saved: "Daalụ maka ịmepụta akaụntụ. Achekwala nnọkọ a.",
    settings: "Ntọala",
    set_new_password: "Tinye paswọọdụ ọhụrụ",
    share: "ike",
    share_to: "ike nye",
    share_with: "ji ike nye:",
    shortcut_to: "Ụzọ mkpirisi ka",
    show_all_windows: "Gosi Windows niile",
    show_hidden: "Gosi ihe ezozo",
    sign_in_with_puter: "Jiri Puter banye",
    sign_up: "Debanye aha",
    signing_in: "Ịbanye…",
    size: "Nha",
    skip: "Mafee",
    something_went_wrong: "Ọ nwere ihe adịghị mma.",
    sort_by: "Hazie site na",
    start: "mbido",
    status: "Ọnọdụ",
    storage_usage: "Ojiji Nchekwa",
    storage_puter_used: "nke Puter na-ji",
    taking_longer_than_usual:
      "Na-ewe obere oge karịa ka ọ dị na mbụ. Biko chere...",
    task_manager: "Onye njikwa ọrụ",
    taskmgr_header_name: "Aha",
    taskmgr_header_status: "Ọnọdụ",
    taskmgr_header_type: "Ụdị",
    terms: "Usoro",
    text_document: "Akwụkwọ ederede",
    tos_fineprint: `Site na ịpị 'Mepụta Akaụntụ efu' ị kwenyere na Puter {{link=terms}} Usoro ọrụ{{/link}} na {{link=privacy}}Amụma nzuzo{{/link}} Puter.`,
    transparency: "nghọta",
    trash: "ahịhịa",
    two_factor: "Nyocha ihe abụọ",
    two_factor_disabled: "Agbanyụrụ 2FA",
    two_factor_enabled: "Agbanyere 2FA",
    type: "Ụdị",
    type_confirm_to_delete_account: "Pịnye 'kwenye' ka ihichapụ akaụntụ gị.",
    ui_colors: "Agba UI",
    ui_manage_sessions: "Onye njikwa oge",
    ui_revoke: "Kagbuo",
    undo: "Megharịa",
    unlimited: "Enweghị oke",
    unzip: "Wepụ ya",
    upload: "Bulite",
    upload_here: "Bulite ebe a",
    usage: "Ojiji",
    username: "Aha njirimara",
    username_changed: "Emelitere aha njirimara nke ọma.",
    username_required: "Achọrọ aha njirimara.",
    versions: "Ụdịdị",
    videos: "Vidiyo",
    visibility: "Nhụta",
    yes: "Ee",
    yes_release_it: "Ee, Hapụ ya",
    you_have_been_referred_to_puter_by_a_friend: "Otu enyi zigara gị na Puter!",
    zip: "Zip",
    zipping_file: "Zipping %strong%",

    // === 2FA Setup ===
    setup2fa_1_step_heading: "Mepee ngwa nyocha",
    setup2fa_1_instructions: `
            Ị nwere ike iji ngwa nyocha ọ bụla na-akwado protocol Paswọdu Otu oge (TOTP) dabere na Oge.
            Enwere ọtụtụ nhọrọ, mana ọ bụrụ na ị maghị
            <a target="_blank" href="https://authy.com/download">Authy</a>
            bụ nhọrọ siri ike maka android na iOS.
        `,
    setup2fa_2_step_heading: "Nyochaa QR koodu",
    setup2fa_3_step_heading: "Tinye koodu ọnụọgụ isi",
    setup2fa_4_step_heading: "Detuo koodu mgbake gị",
    setup2fa_4_instructions: `
            Koodu mgbake ndị a bụ naanị ụzọ ị ga-esi iba akaụntụ gị ma ọ bụrụ na ekwentị gị furu ma ọ bụ enweghị ike iji ngwa nyocha gị..
            Gbaa mbọ hụ na ịchekwaa ha n'ebe dị mma.
        `,
    setup2fa_5_step_heading: "Kwenye ntọlite ​​2FA",
    setup2fa_5_confirmation_1: "Echekwala m koodu mgbake m na ebe echekwa",
    setup2fa_5_confirmation_2: "Adị m njikere i Kwado 2FA",
    setup2fa_5_button: "Kwado 2FA",

    // === 2FA Login ===
    login2fa_otp_title: "Tinye koodu 2FA",
    login2fa_otp_instructions: "Tinye koodu ọnụọgụ isi site na ngwa nyocha.",
    login2fa_recovery_title: "Tinye koodu mgbake",
    login2fa_recovery_instructions:
      "Tinye otu koodu mgbake gị i ji eba akaụntụ gị.",
    login2fa_use_recovery_code: "Ji koodu mgbake",
    login2fa_recovery_back: "Azu",
    login2fa_recovery_placeholder: "XXXXXXXX",

    change: "gbanwee",
    clock_visibility: "Ihe ngosi elekere",
    reading: "ogụgụ %strong%",
    writing: "Na-ede %strong%",
    unzipping: "na mkpọpu ya %strong%",
    sequencing: "usoro %strong%",
    zipping: "zipụ %strong%",
    Editor: "Onye nchịgharị",
    Viewer: "Onye na-ekiri",
    "People with access": "Ndị nwere ohere",
    "Share With…": "Kekọrịta na",
    Owner: "Onye nwe",
    "You can't share with yourself.": "Ị nweghị ike ịkekọrịta ya onwe gị.",
    "This user already has access to this item":
      "Onye a enweela ohere ịbanye ihe a",

    "billing.change_payment_method": "Gbanwee", // In English: "Change"
    "billing.cancel": "Kagbuo", // In English: "Cancel"
    "billing.download_invoice": "Budata", // In English: "Download"
    "billing.payment_method": "Ụzọ nkwụnye ụgwọ", // In English: "Payment Method"
    "billing.payment_method_updated": "Emelitere usoro ịkwụ ụgwọ!", // In English: "Payment method updated!"
    "billing.confirm_payment_method": "Kwenye usoro ịkwụ ụgwọ", // In English: "Confirm Payment Method"
    "billing.payment_history": "Akụkọ ịkwụ ụgwọ", // In English: "Payment History"
    "billing.refunded": "Akwụghachitere", // In English: "Refunded"
    "billing.paid": "Akwụ ụgwọ", // In English: "Paid"
    "billing.ok": "Ọ DỊ MMA", // In English: "OK"
    "billing.resume_subscription": "Malitegharịa ndenye aha", // In English: "Resume Subscription"
    "billing.subscription_cancelled": "Akagbuola ndenye aha gị", // In English: "Your subscription has been canceled."
    "billing.subscription_cancelled_description":
      "Ị ka ga-enwe ike ịnweta ndenye aha gị ruo na njedebe nke oge ịgba ụgwọ a", // In English: "You will still have access to your subscription until the end of this billing period."
    "billing.offering.free": "N'efu", // In English: "Free"
    "billing.offering.pro": "Ọkachamara", // In English: "Professional"
    "billing.offering.professional": "Ọkachamara", // In English: "Professional"
    "billing.offering.business": "Azụmahịa", // In English: "Business"
    "billing.cloud_storage": "Nchekwa igwe ojii", // In English: "Cloud Storage"
    "billing.ai_access": "Nweta AI", // In English: "AI Access"
    "billing.bandwidth": "Bandwit", // In English: "Bandwidth"
    "billing.apps_and_games": "Ngwa & Egwuregwu", // In English: "Apps & Games"
    "billing.upgrade_to_pro": "Kwalite ka sie ike", // In English: "Upgrade to %strong%"
    "billing.switch_to": "Gbanwee na ike", // In English: "Switch to %strong%"
    "billing.payment_setup": "Ntọala ịkwụ ụgwọ", // In English: "Payment Setup"
    "billing.back": "Azu", // In English: "Back"
    "billing.you_are_now_subscribed_to": "Ị debanyere aha na ọkwa siri ike.", // In English: "You are now subscribed to %strong% tier."
    "billing.you_are_now_subscribed_to_without_tier": "Ị debanyere aha ugbu a", // In English: "You are now subscribed"
    "billing.subscription_cancellation_confirmation":
      "Ị ji n'aka na ịchọrọ ịkagbu ndenye aha gị?", // In English: "Are you sure you want to cancel your subscription?"
    "billing.subscription_setup": "Ntọala ndenye aha", // In English: "Subscription Setup"
    "billing.cancel_it": "Kagbuo ya", // In English: "Cancel It"
    "billing.keep_it": "Debe ya", // In English: "Keep It"
    "billing.subscription_resumed": "Eweghachila ndenye aha siri ike gị!", // In English: "Your %strong% subscription has been resumed!"
    "billing.upgrade_now": "Kwalite Ugbu a", // In English: "Upgrade Now"
    "billing.upgrade": "Nweta nkwalite", // In English: "Upgrade"
    "billing.currently_on_free_plan": "Ị nọ ugbu a na atụmatụ efu.", // In English: "You are currently on the free plan."
    "billing.download_receipt": "Budata nnata", // In English: "Download Receipt"
    "billing.subscription_check_error":
      "Nsogbu mere mgbe ị na-elele ọkwa ndenye aha gị.", // In English: "A problem occurred while checking your subscription status."
    "billing.email_confirmation_needed":
      "Ekwenyeghị email gị. Anyị ga-ezitere gị koodu iji gosi ya ugbu a.", // In English: "Your email has not been confirmed. We'll send you a code to confirm it now."
    "billing.sub_cancelled_but_valid_until":
      "Ị kagbuola ndenye aha gị, ọ ga-agbanyekwa na ọkwa efu na-akpaghị aka na njedebe nke oge ịgba ụgwọ. Agaghị akwụ gị ụgwọ ọzọ ọ gwụla ma ị debanyere aha ọzọ", // In English: "You have cancelled your subscription and it will automatically switch to the free tier at the end of the billing period. You will not be charged again unless you re-subscribe."
    "billing.current_plan_until_end_of_period":
      "Atụmatụ gị ugbu a ruo ọgwụgwụ nke oge ịgba ụgwọ a.", // In English: "Your current plan until the end of this billing period."
    "billing.current_plan": "Atụmatụ ugbu a", // In English: "Current plan"
    "billing.cancelled_subscription_tier": "Kagbuo ndenye aha", // In English: "Cancelled Subscription (%%)"
    "billing.manage": "jikwaa", // In English: "Manage"
    "billing.limited": "Oke", // In English: "Limited"
    "billing.expanded": "Gbasaa", // In English: "Expanded"
    "billing.accelerated": "Ọsọ ọsọ", // In English: "Accelerated"
    "billing.enjoy_msg": "Nwee obi ụtọ na Nchekwa igwe ojii gbakwunyere uru ndị ọzọ", // In English: "Enjoy %% of Cloud Storage plus other benefits."

    // =============================================================
    // Missing translations
    // =============================================================
    "choose_publishing_option": undefined, // In English: "Choose how you want to publish your website:"
    "create_desktop_shortcut": undefined, // In English: "Create Shortcut (Desktop)"
    "create_desktop_shortcut_s": undefined, // In English: "Create Shortcuts (Desktop)"
    "create_shortcut_s": undefined, // In English: "Create Shortcuts"
    "minimize": undefined, // In English: "Minimize"
    "reload_app": undefined, // In English: "Reload App"
    "new_window": undefined, // In English: "New Window"
    "open_trash": undefined, // In English: "Open Trash"
    "pick_name_for_worker": undefined, // In English: "Pick a name for your worker:"
    "publish_as_serverless_worker": undefined, // In English: "Publish as Worker"
    "toolbar.enter_fullscreen": undefined, // In English: "Enter Full Screen"
    "toolbar.github": undefined, // In English: "GitHub"
    "toolbar.refer": undefined, // In English: "Refer"
    "toolbar.save_account": undefined, // In English: "Save Account"
    "toolbar.search": undefined, // In English: "Search"
    "toolbar.qrcode": undefined, // In English: "QR Code"
    "used_of": undefined, // In English: "{{used}} used of {{available}}"
    "worker": undefined, // In English: "Worker"
    "billing.offering.basic": undefined, // In English: "Basic"
    "too_many_attempts": undefined, // In English: "Too many attempts. Please try again later."
    "server_timeout": undefined, // In English: "The server took too long to respond. Please try again."
    "signup_error": undefined, // In English: "An error occurred during signup. Please try again."
    "welcome_title": undefined, // In English: "Welcome to your Personal Internet Computer"
    "welcome_description": undefined, // In English: "Store files, play games, find awesome apps, and much more! All in one place, accessible from anywhere at any time."
    "welcome_get_started": undefined, // In English: "Get Started"
    "welcome_terms": undefined, // In English: "Terms"
    "welcome_privacy": undefined, // In English: "Privacy"
    "welcome_developers": undefined, // In English: "Developers"
    "welcome_open_source": undefined, // In English: "Open Source"
    "welcome_instant_login_title": undefined, // In English: "Instant Login!"
    "alert_error_title": undefined, // In English: "Error!"
    "alert_warning_title": undefined, // In English: "Warning!"
    "alert_info_title": undefined, // In English: "Info"
    "alert_success_title": undefined, // In English: "Success!"
    "alert_confirm_title": undefined, // In English: "Are you sure?"
    "alert_yes": undefined, // In English: "Yes"
    "alert_no": undefined, // In English: "No"
    "alert_retry": undefined, // In English: "Retry"
    "alert_cancel": undefined, // In English: "Cancel"
    "signup_confirm_password": undefined, // In English: "Confirm Password"
    "login_email_username_required": undefined, // In English: "Email or username is required"
    "login_password_required": undefined, // In English: "Password is required"
    "window_title_open": undefined, // In English: "Open"
    "window_title_change_password": undefined, // In English: "Change Password"
    "window_title_select_font": undefined, // In English: "Select font…"
    "window_title_session_list": undefined, // In English: "Session List!"
    "window_title_set_new_password": undefined, // In English: "Set New Password"
    "window_title_instant_login": undefined, // In English: "Instant Login!"
    "window_title_publish_website": undefined, // In English: "Publish Website"
    "window_title_publish_worker": undefined, // In English: "Publish Worker"
    "window_title_authenticating": undefined, // In English: "Authenticating..."
    "window_title_refer_friend": undefined, // In English: "Refer a friend!"
    "desktop_show_desktop": undefined, // In English: "Show Desktop"
    "desktop_show_open_windows": undefined, // In English: "Show Open Windows"
    "desktop_exit_full_screen": undefined, // In English: "Exit Full Screen"
    "desktop_enter_full_screen": undefined, // In English: "Enter Full Screen"
    "desktop_position": undefined, // In English: "Position"
    "desktop_position_left": undefined, // In English: "Left"
    "desktop_position_bottom": undefined, // In English: "Bottom"
    "desktop_position_right": undefined, // In English: "Right"
    "item_shared_with_you": undefined, // In English: "A user has shared this item with you."
    "item_shared_by_you": undefined, // In English: "You have shared this item with at least one other user."
    "item_shortcut": undefined, // In English: "Shortcut"
    "item_associated_websites": undefined, // In English: "Associated website"
    "item_associated_websites_plural": undefined, // In English: "Associated websites"
    "no_suitable_apps_found": undefined, // In English: "No suitable apps found"
    "window_click_to_go_back": undefined, // In English: "Click to go back."
    "window_click_to_go_forward": undefined, // In English: "Click to go forward."
    "window_click_to_go_up": undefined, // In English: "Click to go one directory up."
    "window_title_public": undefined, // In English: "Public"
    "window_title_videos": undefined, // In English: "Videos"
    "window_title_pictures": undefined, // In English: "Pictures"
    "window_title_puter": undefined, // In English: "Puter"
    "window_folder_empty": undefined, // In English: "This folder is empty"
    "manage_your_subdomains": undefined, // In English: "Manage Your Subdomains"
    "open_containing_folder": undefined, // In English: "Open Containing Folder"
  },
};

export default ig;
